import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import type { TipTapToolbarProps } from './TipTapToolbar'
const useStyles = makeStyles<Theme>((_theme) => {
  return {
    resetWrapper: {
      display: 'inline-block',
      position: 'absolute',
      right: 0,
      top: -5,
      padding: '5px',
      zIndex: 10
    },
    resetButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      color: 'inherit'
    }
  }
})

export function TipTapResetToolbar(props: TipTapToolbarProps) {
  const { onReset } = props
  const classes = useStyles(props)

  return (
    <>
      {!!onReset && (
        <div className={classes.resetWrapper}>
          <Tooltip title={'Reset to default (generated) value'}>
            <button
              type="reset"
              className={classes.resetButton}
              onMouseDown={(ev) => {
                ev.preventDefault()
                onReset()
              }}
            >
              <CloseIcon fontSize="small" />
            </button>
          </Tooltip>
        </div>
      )}
    </>
  )
}
